import type { ShipmentTag } from '../domain/ShipmentTag'

export type RawShipmentTag = {
  uuid: string
  name: string
  color: string
}

export function mapApiToTags(tags?: Array<RawShipmentTag> | null): Array<ShipmentTag> {
  if (!Array.isArray(tags)) return []

  return tags.map(tag => ({
    uuid: tag.uuid,
    name: tag.name,
    color: tag.color,
  }))
}
